import { loadScript } from '#pplx/frontend/common/loadScript.js';
import { ATTACHMENT_EXTENSIONS, AV_EXTENSIONS, SOURCE_EXTENSIONS, } from '#pplx/frontend/components/hooks/useMicrosoftPickerSupport.js';
import { useCallback, useMemo, useState } from 'react';
function removeDropboxScript() {
    const existingScript = document.getElementById('dropboxjs');
    if (existingScript) {
        document.body.removeChild(existingScript);
    }
}
export const useDropboxPicker = () => {
    const [loadedClientId, setLoadedClientId] = useState(null);
    const ensureScriptLoaded = useCallback(async (clientId) => {
        if (loadedClientId === clientId) {
            return;
        }
        // Remove existing script if different clientId
        removeDropboxScript();
        setLoadedClientId(null);
        await loadScript({
            id: 'dropboxjs',
            src: 'https://www.dropbox.com/static/api/2/dropins.js',
            attrs: {
                'data-app-key': clientId,
            },
        });
        setLoadedClientId(clientId);
    }, [loadedClientId]);
    const openPicker = useCallback(async (options) => {
        await ensureScriptLoaded(options.clientId);
        let extensions = options.mode === 'source' ? SOURCE_EXTENSIONS : ATTACHMENT_EXTENSIONS;
        extensions = options.isAudioVideoFilesEnabled ? extensions.concat(AV_EXTENSIONS) : extensions;
        window.Dropbox.choose({
            success: options.onPicked,
            error: (error) => options.onError?.(error),
            multiselect: true,
            extensions,
            folderselect: options.mode === 'source',
        });
    }, [ensureScriptLoaded]);
    return useMemo(() => ({
        openPicker,
    }), [openPicker]);
};
//# sourceMappingURL=useDropboxPicker.js.map